export default "__VITE_ASSET__C$RJw4QP__"